import "core-js/modules/web.timers.js";
/**
 * @param {Function} callback
 * @param {Number} wait
 * @return {Function}
 */
var debounce = function () {
  var timer = 0;
  return function (callback, wait) {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
}();

/**
 * @return {Boolean}
 */
var isIE = function isIE() {
  return !!document.documentMode;
};
export default {
  debounce: debounce,
  isIE: isIE
};